import { Moon, Sun } from 'lucide-react';
import { Button } from '@heroui/react';
import { useThemeStore } from '../../stores/themeStore';

interface ThemeToggleProps {
  className?: string;
}

export function ThemeToggle({ className }: ThemeToggleProps) {
  const theme = useThemeStore((s) => s.theme);
  const toggleTheme = useThemeStore((s) => s.toggleTheme);
  const isDark = theme === 'dark';

  return (
    <Button
      isIconOnly
      variant="ghost"
      className={className}
      aria-label={isDark ? 'Ativar modo claro' : 'Ativar modo escuro'}
      onPress={toggleTheme}
    >
      {isDark ? <Sun size={18} /> : <Moon size={18} />}
    </Button>
  );
}
